// React
import { useState, useContext, useEffect, useRef } from 'react';

// Global Context
import { GlobalContext } from '../../../contexts/Global';

// Leaflet
import L from "leaflet";

// Kendo
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { orderBy } from "@progress/kendo-data-query";

// Components
import Title from '../../../components/Page/Title';
import Field from '../../../components/Page/Field';

const ConventionalAreasPage = () => {
    const mapRef = useRef();
    const gridRef = useRef();
    const { user } = useContext(GlobalContext);
    const [ areas, setAreas ] = useState([]);
    const [ sort, setSort ] = useState([
        {
            field: "population",
            dir: "desc",
        },
    ]);
    const [ hoveredArea, setHoveredArea ] = useState(null);
    let map = useRef(undefined);
    let geoLayers = useRef({});

    useEffect(()=> {
        map.current = L.map(mapRef.current, {
            center: [ 45.25, 9.6 ],
            preferCanvas: true,
            zoom: 10
        });

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
        }).addTo(map.current);

        fetch(process.env.REACT_APP_API_BASE_URL + "/admin/cers/conventional_areas", {
            headers: {
                Authorization: 'Bearer ' + user.access_token
            }
        })
            .then((response) => response.json())
            .then((response) => {
                setAreas(response.data.areas);

                for (let area of response.data.areas) {
                    const geojsonFeature = JSON.parse(area.geojson);
                    const layer = L.geoJSON(geojsonFeature, {
                        style: {
                            color: '#0074D9',
                            weight: 1,
                            opacity: 0.65,
                            fillOpacity: 0.2
                        }
                    }).addTo(map.current);

                    geoLayers.current[area.code] = layer;
                }
            });
    }, [])

    useEffect(() => {
        Object.values(geoLayers.current).forEach(layer => {
            layer.setStyle({
                color: '#0074D9',
                weight: 1,
                opacity: 0.65,
                fillOpacity: 0.2
            });
        });

        if (hoveredArea && geoLayers.current[hoveredArea]) {
            geoLayers.current[hoveredArea].setStyle({
                color: '#2ECC40',
                weight: 3,
                opacity: 1,
                fillOpacity: 0.5
            });
        }
    }, [ hoveredArea ]);

    useEffect(() => {
        if (areas.length > 0 && gridRef.current) {
            const timeout = setTimeout(() => {
                const rows = gridRef.current.containerRef.current.querySelectorAll('.k-grid-content tbody tr');
                console.log(gridRef.current.containerRef);

                rows.forEach((row, index) => {
                    const sortedAreas = orderBy(areas, sort);
                    const areaCode = sortedAreas[index]?.code;

                    const handleMouseEnter = () => {
                        setHoveredArea(areaCode);
                    };

                    const handleMouseLeave = () => {
                        setHoveredArea(null);
                    };

                    row.removeEventListener('mouseenter', handleMouseEnter);
                    row.removeEventListener('mouseleave', handleMouseLeave);

                    row.addEventListener('mouseenter', handleMouseEnter);
                    row.addEventListener('mouseleave', handleMouseLeave);
                });
            }, 100);

            return () => clearTimeout(timeout);
        }
    }, [ areas, sort ]);

    return (
        <>
            <Title>
                <div>
                    Lista aree convenzionali <small>({ areas.length })</small>
                </div>
            </Title>

            <div className="section grid-template-two-columns">
                <div className="left k-pt-6">
                    <Grid
                        ref={ gridRef }
                        data={ orderBy(areas, sort) }
                        style={{
                            height: "100%",
                        }}
                        scrollable="scrollable"
                        fixedScroll={ true }
                        sort={ sort }
                        onSortChange={(e) => {
                            setSort(e.sort);
                        }}
                    >
                        <GridColumn field="code" title="Codice" />
                        <GridColumn field="main_comune" title="Comune Principale" width="200px" />
                        <GridColumn field="population" title="Popolazione" />
                        <GridColumn field="comuni_province" title="Comuni nella provincia" />
                        <GridColumn field="comuni_area" title="Comuni nell'area" />
                        <GridColumn field="pods_count" title="POD iscritti" />
                    </Grid>
                </div>

                <div className="right">
                    <Field label="Mappa" className="k-h-full">
                        <div ref={ mapRef } />
                    </Field>
                </div>
            </div>
        </>
    );
}

export default ConventionalAreasPage;
